import './public-path';
import { Fragment, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import 'dayjs/locale/zh-cn';
import { ThemeProvider, Themes, isDev, microAppRewrite } from '@maxtropy/components';

import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import isToday from 'dayjs/plugin/isToday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
// polyfill，兼容低版本浏览器
import 'core-js/stable';
import 'regenerator-runtime/runtime';

dayjs.locale('zh-cn');

dayjs.extend(localeData);

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(isToday);
dayjs.extend(weekOfYear);

microAppRewrite();

const root = createRoot(document.getElementById('root') as Element);
const StrictModeComponent = isDev() ? Fragment : StrictMode;
const theme = window.THEME === Themes.LIGHT ? Themes.LIGHT : Themes.DARK;

root.render(
  <StrictModeComponent>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </StrictModeComponent>
);
